import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import AppRoutes from "./routes/route";

import reportWebVitals from "./reportWebVitals";
import store from "./redux/store";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter routter>
    <Provider store={store}>
      <ToastContainer />
      <App />
      <Analytics />
      <SpeedInsights />
    </Provider>
  </BrowserRouter>
);

reportWebVitals();
